export default __webpack_public_path__ + "static/media/ts.c8fe08ac.pdf";